import React from "react";
import { Route, Routes } from "react-router-dom";
import "../src/assets/style/color.scss";
import "../src/assets/style/custome.scss";
import "../src/assets/style/fonts.scss";
import "../src/assets/style/height.scss";
import "../src/assets/style/responsive.scss";
import "../src/assets/style/style.scss";
import "../src/assets/style/width.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import "@progress/kendo-theme-default/dist/all.css";
import UserList from "./screens/AdminList/AdminList";
import Layout from "./components/Layouts/Layout";
import Login from "./screens/Login/Login";
import Registration from "./screens/Login/Registration";
import Role from "./screens/Role/Role";
import AddRole from "./screens/Role/AddRole";
import UsersList from "./screens/UserList/UsersList";
import DeviceList from "./screens/DeviceList/DeviceList";
import DeviceAdd from "./screens/DeviceList/DeviceAdd";
import LocationMarks from "./screens/Locations/LocationMarks";
import ResetPassword from "./screens/Login/ResetPassword";
import MembersList from "./screens/UserList/MembersList";
import Report from "./screens/Report/Report";
import NotificationReport from "./screens/Report/NotificationReport";
import AppLogout from "./components/Layouts/AppLogout";
import Logfile from "./screens/Log/Logfile"
import Company from "./screens/Company/Company";
import CompanyRole from "./screens/CompanyRole/CompanyRole";
import CompanyRoleAdd from "./screens/CompanyRole/CompanyRoleAdd";
import LayoutCompany from "./components/Layouts/LayoutCompany";
import Manager from "./screens/CompanyScreens/Manager/Manager";
import CompanyRoles from "./screens/CompanyScreens/CompanyRoles/CompanyRoles";
import SubAdmin from "./screens/CompanyScreens/Profile/SubAdmin";
import Users from "./screens/CompanyScreens/Profile/Users";
import DeviceCompanyList from "./screens/CompanyScreens/DeviceList/DeviceCompanyList";
import Location from "./screens/CompanyScreens/Location/Location";
import CompanyMembersList from "./screens/CompanyScreens/DeviceList/CompanyMembersList";
import CompanyReport from "./screens/CompanyScreens/DeviceList/CompanyReport";
import CompanyNotificationReport from "./screens/CompanyScreens/DeviceList/CompanyNotificationReport";
import AddCompanyRoles from "./screens/CompanyScreens/CompanyRoles/AddCompanyRoles";
import DailyLog from "./screens/Company/DailyLog";

const ReactRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/registration" element={<Registration />} />
      <Route path="/reset-password/:token" element={<ResetPassword />} />
      <Route element={<Layout />}>
        <Route path="/admin-list" element={<UserList />} />
        <Route path="/role" element={<Role />} />
        <Route path="/add-role" element={<AddRole />} />
        <Route path="/user-list" element={<UsersList />} />
        <Route path="/members-list" element={<MembersList />} />
        <Route path="/device-list" element={<DeviceList />} />
        <Route path="/device-add" element={<DeviceAdd />} />
        <Route path="/report" element={<Report />} />
        <Route path="/notificationreport" element={<NotificationReport />} />
        <Route path="/location-marks" element={<LocationMarks />} />
        <Route path="/log-file" element={<Logfile />} />
        <Route path="/daily-log" element={<DailyLog />} />
        <Route path="/company" element={<Company />} />
        <Route path="/company-role" element={<CompanyRole />} />
        <Route path="/company-role-add" element={<CompanyRoleAdd />} />
      </Route>
      <Route element={<LayoutCompany />}>
        <Route path="/:company/manager" element={<Manager />} />
        <Route path="/:company/role" element={<CompanyRoles />} />
        <Route path="/:company/add-company-role" element={<AddCompanyRoles />} />
        <Route path="/:company/sub-admin" element={<SubAdmin />} />
        <Route path="/:company/users" element={<Users />} />
        <Route path="/:company/device-list" element={<DeviceCompanyList />} />
        <Route path="/:company/members-list" element={<CompanyMembersList />} />
        <Route path="/:company/report-list" element={<CompanyReport />} />
        <Route path="/:company/notification-report-list" element={<CompanyNotificationReport />} />
        <Route path="/:company/location-marks" element={<Location />} />
        <Route path="/:company/daily-log" element={<DailyLog />} />
      </Route>
    </Routes>
  );
};

export default ReactRoutes;
